// Theme Context for Way2Will
// Simplified to just use light theme

import { createContext, useContext, ReactNode } from 'react';

export type ThemeMode = 'light';

interface ThemeContextType {
    theme: ThemeMode;
    resolvedTheme: 'light';
    setTheme: (theme: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
    // Always use light theme
    const theme: ThemeMode = 'light';
    const resolvedTheme = 'light';

    const setTheme = () => {
        // No-op - we only support light theme
    };

    return (
        <ThemeContext.Provider value={{ theme, resolvedTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}
